import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import CertDropdown from '../CertDropdown';

class CertGroup extends Component {
  static propTypes = {
    dealer: PropTypes.shape({}).isRequired
  };


  constructor(props) {
    super(props);

    this.state = {
      accordionOpen: ""

    }

  }

  toggleAccordions(accordionName) {
    const { accordionOpen } = this.state;

    // close drawers for animation
    this.setState({ accordionOpen: '' });

    if (accordionName !== accordionOpen) {
      //then open drawer
      this.setState((state) => ({ accordionOpen: state.accordionOpen === accordionName ? '' : accordionName }));
    }

    let dtmAccordionName;
    const convertName = () => {
      dtmAccordionName = accordionName.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    convertName();

    let accordionDtm = {
      name: 'dealer-details-services-accordion',
      section: 'dealer-details',
      action: dtmAccordionName
    }

    if (typeof _satellite !== 'undefined') {
      window.dtmTrackingDataLayer.event.accordion = accordionDtm;
      _satellite.track('dtmAccordionInteraction', {
        accordionDtm
      });
    }
  }


  render() {
    const { dealer } = this.props;
    const { accordionOpen } = this.state;

    return (
      <Fragment>
        {dealer.isDealerLeafCertified === 'true' && (
          <CertDropdown
            title="Nissan LEAF® Dealer"
            img={dealer.leaf_certified_image}
            alt="LEAF Certified"
            desc={<Text.Body>This Dealer is certified to sell and fully service the Nissan LEAF®.*</Text.Body>}
            disclaimer="Based on latest available list of certified dealers at the time of posting."
            onClick={() => { this.toggleAccordions('leafCertified') }}
            dropDownOpen={accordionOpen === 'leafCertified'}
          />
        )}

        {dealer.isDealerGTRCertified === 'true' && (
          <CertDropdown
            title="Nissan GT-R Dealer"
            img={dealer.gtr_cert_image}
            alt="GTR Certified"
            desc={<Text.Body>This Dealer is certified to sell and fully service the Nissan GT-R.*</Text.Body>}
            disclaimer="Based on latest available list of certified dealers at the time of posting."
            onClick={() => { this.toggleAccordions('gtrCertified') }}
            dropDownOpen={accordionOpen === 'gtrCertified'}
          />
        )}

        {dealer.isDealerWholeSale === 'true' && (
          <CertDropdown
            title="Nissan Wholesale Dealer"
            img="https://www.nissanusa.com/content/dam/Nissan/us/assets/dealers/nissan_wholesale.png"
            alt="Genuine Nissan Parts are sold by this dealer via the Wholesale Channel"
            desc={
              <Fragment>
                <Text.Body>Genuine Nissan Parts are sold by this dealer via the Wholesale Channel. </Text.Body>
                <Text.Body>
                  Genuine Nissan Parts deliver model-specific engineering, perfect fit, reliability, and like new
                  performance. Genuine Nissan Parts fit the first time, helping your customers save time and money.
                </Text.Body>
                <Text.Body>Based on latest available dealers at time of posting.</Text.Body>
              </Fragment>
            }
            onClick={() => { this.toggleAccordions('wholeSale') }}
            dropDownOpen={accordionOpen === 'wholeSale'}
          />
        )}

        {dealer.isDealerCPOCertified === 'true' && (
          <CertDropdown
            title="Certified Pre-Owned Dealer"
            img="https://www.nissanusa.com/content/dam/Nissan/us/assets/dealers/nissan-cpo.jpeg"
            alt="Certified Pre-Owned Dealer"
            desc={<Text.Body>Certified Pre-Owned Dealer</Text.Body>}
            onClick={() => { this.toggleAccordions('cpoCert') }}
            dropDownOpen={accordionOpen === 'cpoCert'}
          />
        )}

        {dealer.dealerProvidesExpressService === 'true' && (
          <CertDropdown
            title="Nissan Express Service Certified Dealer"
            img={dealer.express_service_image}
            alt="Express Service Award"
            desc={
              <Fragment>
                <Text.Body>
                Nissan Express Service is offered at this dealer. Express Service is the same expert service you trust; now faster, more convenient and competitive with the highest quality from factory trained Nissan technicians. And you don't need an appointment!
                </Text.Body>
                <Text.Body>
                Every Express Service Oil & Filter change will include a complementary Multi-Point Inspection. Ask your dealer about other Express Services.
                </Text.Body>
              </Fragment>
            }
            onClick={() => { this.toggleAccordions('expressService') }}
            dropDownOpen={accordionOpen === 'expressService'}
          />
        )}

        {dealer.isDealerOfferingRental === 'true' && (
          <CertDropdown
            title="Nissan Rental Car Dealer"
            img={dealer.nissanRental_cert_image}
            alt="Dealer offers Rentals"
            desc={
              <Text.Body>
                This dealer offers Nissan vehicles for rental.* Renting a vehicle from your dealer is a great way to
                experience our products and offers a convenient alternative during vehicle service.
              </Text.Body>
            }
            disclaimer="Based on latest available list of dealers at the time of posting."
            onClick={() => { this.toggleAccordions('offeringRental') }}
            dropDownOpen={accordionOpen === 'offeringRental'}
          />
        )}

        {dealer.isDealerOwnerFirst === 'true' && (
          <CertDropdown
            title="Nissan Award of Excellence"
            img="https://www.nissanusa.com/content/dam/Nissan/us/assets/dealers/nissan-aoe-2021.png"
            alt="Excellence Award"
            desc={
              <Text.Body>
                The Nissan Award of Excellence is the highest award presented by Nissan North America to our Dealers.
                This award recognizes Nissan's top Dealers from across the nation who are able to meet high standards of
                achievement. These Nissan Award of Excellence Dealerships embody the philosophy and vision, to provide
                our customers with an outstanding ownership experience, from the showroom through every aspect of the
                dealership.
              </Text.Body>
            }
            onClick={() => { this.toggleAccordions('ownerFirst') }}
            dropDownOpen={accordionOpen === 'ownerFirst'}
          />
        )}

        {dealer.isDealerGAoE === 'true' && (
          <CertDropdown
            title="Nissan Global Award of Excellence"
            img="https://www.nissanusa.com/content/dam/Nissan/us/assets/dealers/nissan-gaoe-2023.png"
            alt="Global Award of Excellence"
            desc={
              <Text.Body>
                Dealers who achieve Nissan Award of Excellence are ranked nationally and the Top 50 dealers are awarded
                the Nissan Global Award. This award is from Nissan Motor Company, LTD in Japan and is given to elite
                dealerships across the world.
              </Text.Body>
            }
            onClick={() => { this.toggleAccordions('gAoE') }}
            dropDownOpen={accordionOpen === 'gAoE'}
          />
        )}

        {dealer.isCustomerPromise === 'true' && (
          <CertDropdown
            title="Customer Promise Certified Dealer"
            img={dealer.customerPromise_cert_image}
            alt="Customer Promise Award"
            desc={
              <Fragment>
                <Text.Body>
                  At Nissan, we believe the treatment you receive is just as important as the vehicle you own.
                </Text.Body>
                <Text.Body>
                  The Nissan Customer Promise Certification means this dealer is committed to giving you the best
                  customer service possible.
                </Text.Body>
              </Fragment>
            }
            onClick={() => { this.toggleAccordions('promise') }}
            dropDownOpen={accordionOpen === 'promise'}
          />
        )}

        {dealer.isDealerOneToOneRewards === 'true' && (
          <CertDropdown
            title="One To One Rewards"
            img={dealer.oneTone_cert_image}
            alt="One to One Rewards"
            desc={
              <Text.Body>
                The Nissan One To One Rewards program is a loyalty program designed for YOU to earn valuable points at
                your Nissan dealership. You earn points based on every dollar you spend at your participating Nissan
                dealership. You can then redeem those points on your next service visit, for parts or accessories
                purchases, or, if you choose, for your next new or used vehicle purchased at your Nissan dealership.
              </Text.Body>
            }
            onClick={() => { this.toggleAccordions('oneToOneRewards') }}
            dropDownOpen={accordionOpen === 'oneToOneRewards'}
          />
        )}

        {dealer.isEcommerce === 'true' && (
          <CertDropdown
            title="NISSAN INTERNET CERTIFIED DEALER"
            img={dealer.ecommerce_image}
            alt="eStore"
            desc={
              <Fragment>
                <Text.Body>
                  A Nissan Internet Certified Dealer has been recognized for achievement in online customer relations.
                  Internet Certified Dealers are continually measured against performance criteria including response
                  time to e-mail inquiries, customer survey results and overall quality of communications.
                </Text.Body>
                <Text.Body>
                  Nissan will continually strive to deliver an online shopping experience that exceeds your
                  expectations.
                </Text.Body>
              </Fragment>
            }
            onClick={() => { this.toggleAccordions('eccomerce') }}
            dropDownOpen={accordionOpen === 'eccomerce'}
          />
        )}

        {dealer.isCollisionRepair === 'true' && (
          <CertDropdown
            title="Certified Collision Repair Shop"
            img={dealer.collisionRepair_image}
            alt="Collision Repair"
            desc={
              <Fragment>
                <Text.Body>
                  This Dealer has sponsored a body shop meeting the requirements of the Nissan Certified Collision
                  Repair Network shop program. This program recognizes distinguished body shops that meet or exceed
                  standards for repairs, training, equipment, and delivery of service. Taking the worry out of collision
                  repairs.
                </Text.Body>
                <Text.Body>
                  This Dealer has sponsored a body shop meeting the requirements of the Nissan Certified Collision
                  Repair Network shop program. This program recognizes distinguished body shops that meet or exceed
                  standards for repairs, training, equipment, and delivery of service. Taking the worry out of collision
                  repairs.
                </Text.Body>
              </Fragment>
            }
            onClick={() => { this.toggleAccordions('collisonRepair') }}
            dropDownOpen={accordionOpen === 'collisonRepair'}
          />
        )}
      </Fragment>
    );
  }
}

export default CertGroup;
